import { Directive, HostListener, Inject } from '@angular/core';
import { WindowShellComponent } from '../components/window-shell/window-shell.component';
import { WINDOW_REF } from '../providers';

@Directive({
  selector: '[bmWindowClose]'
})
export class WindowCloseDirective {

  constructor(@Inject(WINDOW_REF) private windowRef: WindowShellComponent) { }

  @HostListener('click')
  closeWindow() {
    this.windowRef.close();
  }

}
